import { observable, action, autorun, computed, toJS } from 'mobx'
import http from 'src/helper/http'
import cdn from 'src/helper/cdn'


export default class {
  @observable data = {
    userInfo: {}
  }

  @action async GetUserInfoWeb(uid) {
    let d = await http.post('/web/MyAccountInfo', { uid: uid })
    if (d && d.code == 0 && d.res && d.res.uid > 0) {
      this.data.userInfo = d.res
      return d && d.res
    }
  }

  @action async searchUserInfo(uidDuid) {
    let d = await http.post('/web/user/info', { uidDuid })
    return d
  }



  // 用户红宝石信息
  @action async userRubyInfo(ruby) {
    let res = await http.post('/web/user/info/ruby', { ruby })
    if (res && res.code == 0) {
      return res.res
    }
  }
  // 红宝石兑换
  @action async rubyExchange(ruby) {
    let res = await http.post('/web/ruby/exchange', { ruby })
    if (res && res.code == 0) {
      return res.res
    } else {
      return res
    }
  }
  // 红宝石兑换记录
  @action async rubyExchangeList(scroll) {
    let res = await http.post('/web/ruby/exchange/record', { scroll })
    if (res && res.code == 0) {
      return res.res
    }
  }

  // 提现等级列表
  @action async getWithdrawalLvList() {
    let res = await http.post('/web/ruby/withdrawalLv/list', {})
    if (res && res.code == 0) {
      return res.res
    }
  }

  // 申请加入host状态
  @action async applyHostState() {
    let res = await http.post('/web/ruby/host/ststem/apply/state', {})
    if (res && res.code == 0) {
      return res.res
    }
  }
  // 申请加入host
  @action async applyHost() {
    let res = await http.post('/web/ruby/host/ststem/apply', {})
    if (res && res.code == 0) {
      return res.res
    }
  }



  // 提现
  @action async onWithdrawal({ familyId, owner, ruby }) {
    let res = await http.post('/web/ruby/withdrawal', { familyId, owner, ruby })
    return res
  }

  // 提现记录（族长
  @action async familyWithdrawalList({ scroll, familyId }) {
    let res = await http.post('/web/ruby/withdrawal/record/family', { scroll, familyId })
    if (res && res.code == 0) {
      return res
    }
  }

  // 提现记录（用户
  @action async userWithdrawalList(scroll) {
    let res = await http.post('/web/ruby/withdrawal/record/user', { scroll })
    if (res && res.code == 0) {
      return res
    }
  }


  // 族长处理
  @action async onFamilyWithdrawal({ images, id }) {
    let res = await http.post('/web/ruby/withdrawal/set/success', { images, id })
    if (res && res.code == 0) {
      return res
    }
  }

  // 族长信息
  @action async familyInfo() {
    let res = await http.post('/web/family/info', {})
    if (res && res.code == 0) {
      return res.res
    }
  }



  //  @ 金币、红宝石代理模块

  // 代理金币列表
  @action goldList() {
    return [
      {
        gold: 1000,
        price: 1 * 100
      },
      {
        gold: 10000,
        price: 10 * 100
      },
      {
        gold: 50000,
        price: 50 * 100
      },
      {
        gold: 75000,
        price: 75 * 100
      },
      {
        gold: 105000,
        price: 100 * 100
      },
      {
        gold: 210000,
        price: 200 * 100
      },
      {
        gold: 315000,
        price: 300 * 100
      },
      {
        gold: 525000,
        price: 500 * 100
      },
      {
        gold: 1050000,
        price: 1000 * 100
      },
      {
        gold: 5250000,
        price: 5000 * 100
      },
      {
        gold: 10500000,
        price: 10000 * 100
      }
    ]
  }
  // 代理金币充值
  @action async goldAgentRecharge(uidDuid, dollar, val) {
    let res = await http.post('/web/AgentGold', { uidDuid, dollar, val })
    return res
  }

  // 代理红宝石列表
  @action async rubyAgentList() {
    let res = await http.post('/web/product/ruby/agent', {})
    if (res && res.code == 0) {
      return res.res
    }
  }
  // 代理红宝石充值
  @action async rubyAgentRecharge(uidDuid, dollar, val) {
    let res = await http.post('/web/agent/ruby/recharge', { uidDuid, dollar, val })
    return res
  }

  // 列表记录
  @action async agentRubyRecordList(scroll) {
    let res = await http.post('/web/agent/recharge/ruby/record', { scroll })
    return res
  }
  @action async agentGoldRecordList(scroll) {
    let res = await http.post('/web/UserExtendRecordList', { scroll })
    return res
  }
}


// WEBPACK FOOTER //
// src/store/app/ruby.js